<template>
  <v-dialog
    v-model="dialog"
    width="500px"
    style="z-index: 9999;"
  >
    <v-card>
      <v-toolbar dense elevation="0">
        <v-toolbar-title>{{ $t("dialog.company_selection.title") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-text-field
          :label="$t('dialog.company_selection.filter')"
          v-model="companyFilter"
          autofocus
          solo
          flat
          hide-details
          prepend-inner-icon="mdi-filter"
          style="width: 40px"
        ></v-text-field>
        <v-btn icon @click="dialog=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider class="mx-2" />

      <v-virtual-scroll ref="vscroll" :items="filteredCompanies" bench="1064" min-height="104px" max-height="50vh"
                        item-height="54">
        <template v-slot:default="{ item }">
          <v-list-item :key="item.companyId" @click="companySelect(item)">
            <v-list-item-icon>
              <country-flag :country="item.countryCode" size="normal" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-virtual-scroll>
    </v-card>
  </v-dialog>
</template>

<script>

import utils from "@/utils";

export default {
  name: "CompanySelectionDialog",

  data() {
    return {
      dialog: false,
      companyFilter: null
    };
  },

  methods: {
    open() {
      this.companyFilter = null;
      this.dialog = true;

      this.$nextTick().then(() => {
        this.$refs.vscroll.$el.scrollTop = 1;
        this.$refs.vscroll.$el.scrollTop = 0;
      });
    },

    companySelect(item) {
      this.$emit("selected", item);
      this.dialog = false;
    },

    keyEvent(keyEvent) {
      if (!this.dialog)
        return;

      if (keyEvent.key === "Enter") {
        const companies = this.filteredCompanies;

        if (companies.length === 1)
          this.companySelect(companies[0]);
      }
    }
  },

  watch: {
    dialog(newValue) {
      if (newValue === false)
        this.$store.dispatch("dialogs/hideDialog", "companySelection");
    }
  },

  computed: {
    userCompanies() {
      return this.$store.state.auth.token.companies;
    },

    filteredCompanies() {
      if (this.companyFilter != null)
        return this.$store.state.auth.token.companies.filter(
          x => utils.searchNormalized(x.name, this.companyFilter));
      else
        return this.$store.state.auth.token.companies;
    }
  },

  mounted() {
    document.addEventListener("keydown", this.keyEvent);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.keyEvent);
  }
};
</script>